/**
 * Users Routes
 */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Helmet } from "react-helmet";
import PrivateRoute from "../../container/PrivateRoute"
// async components

import {
    AsyncAuditLogListComponent
} from 'Components/AsyncComponent/AsyncComponent';
 

const AuditLogs = ({ match }) => (
    <div className="content-wrapper">
        <Helmet>
            <title>Audit Logs</title>
            <meta name="description" content="Audit Logs" />
        </Helmet>

        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/auditlog-list`} />
            <Route path={`${match.url}/auditlog-list`} render={(props) => <PrivateRoute {...props} claims={["Admin"]} routecomponent={AsyncAuditLogListComponent} />} />
        </Switch>
    </div>
);


export default AuditLogs;
